import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { breakpointUp } from '../utils/breakpoints';
import Lottie from 'lottie-web';

gsap.registerPlugin(ScrollTrigger);

let parallaxTimeline = null;
let current_page = document.documentElement.getAttribute('data-page');
let current_url = document.documentElement.getAttribute('data-url');

function initializeParallax() {
  // Clear any previous timelines if they exist
  if (parallaxTimeline) {
    ScrollTrigger.getById('parallax-scroll-trigger')?.kill(true);
    parallaxTimeline.kill(true);
    parallaxTimeline = null;
  }

  // Check breakpoint
  if ($(window).width() >= 1024) {
    // Create a new timeline
    parallaxTimeline = gsap.timeline({
      scrollTrigger: {
        id: 'parallax-scroll-trigger',
        trigger: "#parallax-animation",
        start: "top bottom",
        end: "bottom center",
        scrub: true,
        //markers: true
      }
    });

      // Initialize parallax animations
      gsap.utils.toArray(".parallax").forEach(layer => {
        const depth = layer.dataset.depth;
        const movement = -(layer.offsetHeight * depth);
        parallaxTimeline.to(layer, { y: movement, ease: "none" }, 0);
      });

      const parallax2 = document.querySelector('.parallax-2');
      if (parallax2) {
        parallax2.style.bottom = '-17rem';
      }
    }
}

function isIndexPage() {
  return current_page === 'index';
}

function isAboutPage() {
  return current_page === 'about-us';
}

if (isIndexPage() || isAboutPage()) {
  const handleResize = () => {
    const backgroundImage = document.querySelector('.block-about-us-page .parallax');
    const backgroundImageIndex = document.querySelector('.parallax');
    const marginChange = document.querySelector('.block-about-us-page .block-margin');
    if (backgroundImage && marginChange && window.innerWidth < 1024) {
      backgroundImage.style.transform = 'translateY(0rem)';
      marginChange.style.marginBottom = '3rem';
    }
    if (!backgroundImage && backgroundImageIndex && window.innerWidth < 1024) {
      backgroundImageIndex.style.transform = 'translateY(2rem)';
    }
  };

  // Initial call to setup parallax
  initializeParallax();

  const resizeObserver = new ResizeObserver(() => {
    handleResize();
    initializeParallax();
  });

  resizeObserver.observe(document.body);

  // Reinitialize on window resize
  let lastWidth = $(window).width();
  $(window).on('resize', function () {
    const currentWidth = $(window).width();
    if (currentWidth !== lastWidth) {
      lastWidth = currentWidth;
      setTimeout(() => {
        initializeParallax();
      }, 300);
    }
  });
}

export function setupAboutUsLottie() {
  let aboutUsIcon = $('.about-us-lottie-icon');
  if (!aboutUsIcon.length) {
    return false;
  }
    let animation = Lottie.loadAnimation({
      container: aboutUsIcon[0],
      renderer: 'svg',
      loop: false,
      autoplay: true,
      path: aboutUsIcon.data('src')
    });

    animation.addEventListener('DOMLoaded', () => {
      animation.play();
      animation.addEventListener('complete', () => {
        setTimeout(() => {
          animation.goToAndPlay(0);
        }, 4000);
      });
    });
}

export function animateAboutUs() {
  const elementsToAnimate = document.querySelectorAll('.block-head, .timeline-container, .about-us-lottie-icon, .timeline-text-slider');

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: elementsToAnimate[0],
      start: 'top center',
      end: 'bottom 20%',
      toggleActions: 'play none none reverse'
    }
  });

  tl.from('.block-head', {
    opacity: 0,
    y: 50,
    duration: 1.5,
    ease: 'power4'
  })
    .from('.timeline-container', {
      opacity: 0,
      y: 50,
      duration: 1.5,
      ease: 'power4'
    }, '-=1.3')
    .from(['.about-us-lottie-icon', '.timeline-text-slider'], {
      opacity: 0,
      y: 50,
      duration: 1.5,
      ease: 'power4'
    }, '-=1.3');
}
// $(window).on('load', function () {
//   setupHeroLottie();
// });

export function setupHeroLottie() {
  let heroIcon = $('.about-us-lottie-icon-hero');
  if (!heroIcon.length) { return; }

  let heroAnimation = Lottie.loadAnimation({
    container: heroIcon[0],
    animType: 'svg',
    loop: true,
    autoplay: true,
    path: heroIcon.data('src')
  });
  heroAnimation.addEventListener('complete', () => {
    setTimeout(() => {
      heroAnimation.goToAndPlay(0);
    }, 4000);
  });
}
